// extracted by mini-css-extract-plugin
export default {"host":"style_host__asxvS","border":"style_border__5PfG9","button":"style_button__aBPgB","rounded":"style_rounded__0YvSS","small":"style_small__oYbi-"};